module.exports = __webpack_public_path__ + "@/assets/img/mak100.99b243ea.jpeg";